var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M3,17a3,3,0,0,1-3-3V8A1,1,0,0,1,2,8v6a1,1,0,0,0,1,1H19a1,1,0,0,0,1-1V10.09a1,1,0,0,1,2,0V14a3,3,0,0,1-3,3ZM7.981,2a1,1,0,1,1,0-2H15a1,1,0,0,1,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,3A3,3,0,0,0-3,0,3,3,0,0,0-6,3,3,3,0,0,0-3,6,3,3,0,0,0,0,3Z",
    transform: "translate(22 2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,3A3,3,0,0,0-3,0,3,3,0,0,0-6,3,3,3,0,0,0-3,6,3,3,0,0,0,0,3Z",
    transform: "translate(14 6)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,3A3,3,0,0,0-3,0,3,3,0,0,0-6,3,3,3,0,0,0-3,6,3,3,0,0,0,0,3Z",
    transform: "translate(6)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,3.724-.891,1.933l-4.013,2,.89,1.791Zm-6.884.27L-12.87,0l-1.111,1.664,5.987,3.993Z",
    transform: "translate(17.56 3.185)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,7,1.4,0H7.04l1.4,7Z",
    transform: "translate(6.78 15)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M11,0a1,1,0,0,1,0,2H1A1,1,0,0,1,1,0Z",
    transform: "translate(5 20)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.873544e9df5999191a3ad2002fb62a9c.svg";
export { ForwardRef as ReactComponent };